import { render, staticRenderFns } from "./HouseAmenity.vue?vue&type=template&id=90cae0d6&scoped=true&"
import script from "./HouseAmenity.vue?vue&type=script&lang=js&"
export * from "./HouseAmenity.vue?vue&type=script&lang=js&"
import style0 from "./HouseAmenity.vue?vue&type=style&index=0&id=90cae0d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cae0d6",
  null
  
)

export default component.exports